import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { getAllUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { generateQueryParams } from "../../../../utils/helpers/generateQueryParams";
import { useDealData } from "./useDealData"; // Make sure this path is correct

export const useCachedDealData = (
  dealId,
  initialDataFromLocation = null,
  forceReload
) => {
  const queryClient = useQueryClient();
  const urlParams = getAllUrlParams();

  const { filters } = useSelector((state) => state.filter);
  const dealsFilters = filters.deals || [];

  const { queryParams, params } = generateQueryParams(dealsFilters);

  const allDealsData = queryClient.getQueryData([
    "deals",
    urlParams?.page * 1,
    urlParams?.limit * 1,
    params?.toString(),
    queryParams?.toString(),
    urlParams?.companyid,
    "-leadToDealOn",
  ])?.data?.data;

  const cachedDealData = allDealsData?.find((deal) => deal._id === dealId);

  let shouldFetchFresh = forceReload || !cachedDealData;
  if (!dealId) {
   shouldFetchFresh = false; 
    
  }

  const {
    dealData: fetchedDealData,
    isLoading,
    isError,
    error,
  } = useDealData(dealId, shouldFetchFresh);

  const dealData = shouldFetchFresh
    ? fetchedDealData
    : cachedDealData || initialDataFromLocation;

  return {
    dealData,
    isLoading,
    isError,
    error,
  };
};
